const getSubdomain = () => {
  const { hostname } = window.location;
  const subdomain = hostname.split(".")[0];
  return subdomain;
};

export default getSubdomain;
